import './index.css'

import _ from 'lodash'
import { toJS } from 'mobx'
import { observer } from 'mobx-react'
import React from 'react'
import { Responsive, WidthProvider } from 'react-grid-layout'

import {
  ClickAwayListener,
  Fab,
  MenuItem,
  MenuList,
  Popover,
  PopoverPosition
} from '@material-ui/core'
import AddIcon from '@material-ui/icons/Add'

import Block from './components/Block'
import store, { BlockType } from './store'

const ResponsiveReactGridLayout = WidthProvider(Responsive)

function App() {
  const [open, setOpen] = React.useState(false)
  const [anchorPosition, setAnchorPosition] = React.useState<
    PopoverPosition | undefined
  >(undefined)

  const [mounted, setMounted] = React.useState(false)

  const anchorRef = React.useRef<any | null>(null)
  const handleToggle = () => {
    setOpen(prevOpen => !prevOpen)
  }
  const handleClose = (e: React.MouseEvent<any, any>) => {
    e.preventDefault()
    e.stopPropagation()
    setAnchorPosition(undefined)
    setOpen(false)
  }

  React.useEffect(() => {
    setMounted(true)
  }, [])

  const onOptionSelect = (type: BlockType) => (
    e: React.MouseEvent<HTMLLIElement, MouseEvent>
  ) => {
    e.stopPropagation()
    e.preventDefault()
    handleClose(e)
    store.addBlock(type)
  }
  return (
    <div
      className="App"
      style={{ minHeight: '100vh', minWidth: '100vw' }}
      onContextMenu={e => {
        e.preventDefault()
        e.stopPropagation()
        setAnchorPosition({ left: e.clientX, top: e.clientY })
      }}
    >
      <Fab
        ref={anchorRef}
        color="primary"
        aria-label="add"
        onClick={handleToggle}
        style={{ position: 'absolute', right: 20, bottom: 25, zIndex: 5 }}
      >
        <AddIcon />
      </Fab>
      <Popover
        anchorReference={anchorPosition ? 'anchorPosition' : 'anchorEl'}
        anchorEl={anchorRef.current}
        open={!!anchorPosition || open}
        style={{ zIndex: 9 }}
        anchorPosition={anchorPosition}
        onClose={handleClose}
        anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'left'
        }}
        disablePortal
      >
        <ClickAwayListener onClickAway={handleClose}>
          <MenuList>
            <MenuItem onClick={onOptionSelect('DEFAULT')}>Default</MenuItem>
            <MenuItem onClick={onOptionSelect('FILE')}>File</MenuItem>
            <MenuItem onClick={onOptionSelect('TEXT')}>Text</MenuItem>
            <MenuItem onClick={onOptionSelect('LINK')}>Link</MenuItem>
            <MenuItem onClick={onOptionSelect('NOTE')}>Note</MenuItem>
          </MenuList>
        </ClickAwayListener>
      </Popover>
      <ResponsiveReactGridLayout
        rowHeight={30}
        cols={{ lg: 12, md: 10, sm: 6, xs: 4, xxs: 2 }}
        layouts={{
          lg: toJS(store.layout)
        }}
        // onBreakpointChange={breakpoint => setCurrentBreakpoint(breakpoint)}
        onLayoutChange={_layout => {
          store.updateLayout(_layout)
        }}
        autoSize
        // WidthProvider option
        measureBeforeMount={false}
        // I like to have it animate on mount. If you don't, delete `useCSSTransforms` (it's default `true`)
        // and set `measureBeforeMount={true}`.
        useCSSTransforms={mounted}
        // compactType={compactType}
        // preventCollision={!compactType}
      >
        {/* {generateDOM()} */}
        {store.blocks.map(b => (
          <div key={b.id} style={{}}>
            <Block block={b} />
          </div>
        ))}
      </ResponsiveReactGridLayout>
    </div>
  )
}

export default observer(App)
